import React from 'react';
import { List as AntList, Avatar, Typography, Space } from 'antd';

type Props = {
    data: any[];
    title: string;
    description?: string;
    colorTitle: string;
    colorName: string;
};

const List: React.FC<Props> = ({
    data,
    title,
    description,
    colorTitle,
    colorName,
}) => {
    const { Title } = Typography;
    return (
        <div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: '1em',
                }}
            >
                <Title level={5} style={{ color: colorTitle }}>
                    {title}
                </Title>
            </div>
            <AntList
                itemLayout="horizontal"
                dataSource={data}
                size="small"
                split={false}
                style={{ paddingBottom: '1em' }}
                renderItem={(item) => (
                    <AntList.Item>
                        <AntList.Item.Meta
                            avatar={
                                <Avatar src="https://joeschmoe.io/api/v1/random" />
                            }
                            title={
                                <span style={{ color: colorName }}>
                                    {item.title}
                                </span>
                            }
                            description="Colaborador"
                        />
                    </AntList.Item>
                )}
            />
        </div>
    );
};

export default List;
